jQuery(function($){

  $('html').removeClass('no-js');
                    
  /* Placeholder JS */
  /*==========================*/

  $('[placeholder]').each(function(){
    if ($(this).val() === '') {
      var hint = $(this).attr('placeholder');
      $(this).val(hint).addClass('hint');
    }
  });

  $('[placeholder]').focus(function() {
    if ($(this).val() === $(this).attr('placeholder')) {
      $(this).val('').removeClass('hint');
    }
  }).blur(function() {
    if ($(this).val() === '') {
      $(this).val($(this).attr('placeholder')).addClass('hint');
    }
  });                    

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });

  $('.col-xs-12').on('mouseenter', '.box-slider', function(){
    $(this).find('.box-slider-text').animate({'top' : '100px' }, 200);
  }).on('mouseleave', '.box-slider', function(){
    $(this).find('.box-slider-text').animate({'top' : '250px' }, 200);
  });
  $('li').on('mouseenter', '.box-slider', function(){
    $(this).find('.box-slider-text').animate({'top' : '100px' }, 200);
  }).on('mouseleave', '.box-slider', function(){
    $(this).find('.box-slider-text').animate({'top' : '200px' }, 200);
  });

});
